import axios from "axios";
import { redirectToLogin } from "../login";

const instance = axios.create({
  // baseURL: 'https://dsmpl-backend-dot-gate-project-409316.uc.r.appspot.com/api',
  baseURL: `${process.env.REACT_APP_CORE_API}/api`,
});

instance.interceptors.request.use(async function (config) {
  const loggedInToken = localStorage.getItem("authorization");
  config["headers"]["Authorization"] = `Bearer ${loggedInToken}`;

  return config;
});

// Expired/invalid token -> clear session and send the user to login
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      redirectToLogin();
    }
    return Promise.reject(error);
  }
);

export default instance;
